<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import {
  required,
  minLength,
  maxLength,
  requiredIf,
  email,
} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

import { gender, certificate, country, city } from "../../helpers/lists";

export default {
  components: { DatePicker, Multiselect },
  props: {},
  data() {
    return {
      name1: "",
      name2: "",
      name3: "",
      artistic_name: "",

      birth_date: "",
      gender_id: "",
      phone1: "",
      phone2: "",
      certificate_id: "",
      academic_specialization: "",
      email: "",
      country_id: "",
      city_id: "",
      city_name: "",

      phone1Prefix: "",
      phone2Prefix: "",
      phoneLength: 11,

      //lists
      list_gender: gender,
      list_certificate: certificate,
      list_city: city,
      list_country: country,
    };
  },
  validations() {
    return {
      name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
      name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
      name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
      artistic_name: { minLength: minLength(2), maxLength: maxLength(50) },
      birth_date: {
        required,
        maxValue: this.maxBirthDate(),
      },
      gender_id: { required },
      certificate_id: { required },
      country_id: { required },
      academic_specialization: { minLength: minLength(2), maxLength: maxLength(50) },
      phone1: {
        required,
        minLength: minLength(this.phoneLength),
        maxLength: maxLength(this.phoneLength),
      },
      phone2: {
        minLength: minLength(this.phoneLength),
        maxLength: maxLength(this.phoneLength),
      },
      email: { email, maxLength: maxLength(50) },
      city_id: {
        required: requiredIf(function () {
          return this.isIraq();
        }),
      },
      city_name: {
        required: requiredIf(function () {
          return !this.isIraq();
        }),
        minLength: minLength(2),
        maxLength: maxLength(50),
      },
      form: [
        "name1",
        "name2",
        "name3",
        "artistic_name",
        "birth_date",
        "gender_id",
        "phone1",
        "phone2",
        "certificate_id",
        "academic_specialization",
        "email",
        "country_id",
        "city_id",
        "city_name",
      ],
    };
  },

  methods: {
    customLabel({ title, desc }) {
      return `${title} – ${desc}`;
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
    isIraq() {
      return this.country_id.id == 39;
    },
    // التحقق من أن تاريخ الميلاد أقدم من 4 سنوات
    maxBirthDate() {
      return (value) => {
        if (!value) return true; // في حال كان الحقل فارغًا، نسمح له
        const [year, month, day] = value.split("-");
        const birthDate = new Date(year, month - 1, day);
        const today = new Date();
        const minAllowedDate = new Date(
          today.getFullYear() - 4,
          today.getMonth(),
          today.getDate()
        );
        return birthDate <= minAllowedDate;
      };
    },
  },
  watch: {
    country_id(newVal) {
      if (newVal && newVal.phone_code && newVal.phone_length) {
        this.phone1Prefix = newVal.phone_code;
        this.phone2Prefix = newVal.phone_code;
        this.phoneLength = newVal.phone_length;

        this.phone1 = "";
        this.phone2 = "";

        // لإعادة تفعيل التحقق مع القيم الجديدة
        // this.$v.$reset();
        // this.$nextTick(() => {
        //   this.$v.$touch();
        // });
      }
    },
  },
  created() {},
  computed: {
    isCountrySelected() {
      return !!(
        this.country_id &&
        this.country_id.phone_code &&
        this.country_id.phone_length
      );
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <div class="title-separator">
        <h4>{{ $t("components.artist_info.title") }}</h4>
      </div>

      <div class="col-md-12 con-all-form">
        <div class="row">
          <b-form-group class="col-md-3 mb-3">
            <label for="name1"
              >{{ $t("components.artist_info.name1.label")
              }}<span class="required">*</span></label
            >
            <b-form-input
              id="name1"
              type="text"
              :placeholder="$t('components.artist_info.name1.placeholder')"
              v-model="name1"
              :class="{ 'is-invalid': $v.name1.$error }"
            ></b-form-input>
            <div v-if="$v.name1.$error" class="invalid-feedback">
              <span v-if="!$v.name1.required">{{
                $t("components.artist_info.name1.validation.required")
              }}</span>
              <span v-if="!$v.name1.minLength">{{
                $t("components.artist_info.name1.validation.minLength")
              }}</span>
              <span v-if="!$v.name1.maxLength">{{
                $t("components.artist_info.name1.validation.maxLength")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3">
            <label for="name2"
              >{{ $t("components.artist_info.name2.label")
              }}<span class="required">*</span></label
            >
            <b-form-input
              id="name2"
              type="text"
              :placeholder="$t('components.artist_info.name2.placeholder')"
              v-model="name2"
              :class="{ 'is-invalid': $v.name2.$error }"
            ></b-form-input>
            <div v-if="$v.name2.$error" class="invalid-feedback">
              <span v-if="!$v.name2.required">{{
                $t("components.artist_info.name2.validation.required")
              }}</span>
              <span v-if="!$v.name2.minLength">{{
                $t("components.artist_info.name2.validation.minLength")
              }}</span>
              <span v-if="!$v.name2.maxLength">{{
                $t("components.artist_info.name2.validation.maxLength")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3">
            <label for="name3"
              >{{ $t("components.artist_info.name3.label")
              }}<span class="required">*</span></label
            >
            <b-form-input
              id="name3"
              type="text"
              :placeholder="$t('components.artist_info.name3.placeholder')"
              v-model="name3"
              :class="{ 'is-invalid': $v.name3.$error }"
            ></b-form-input>
            <div v-if="$v.name3.$error" class="invalid-feedback">
              <span v-if="!$v.name3.required">{{
                $t("components.artist_info.name3.validation.required")
              }}</span>
              <span v-if="!$v.name3.minLength">{{
                $t("components.artist_info.name3.validation.minLength")
              }}</span>
              <span v-if="!$v.name3.maxLength">{{
                $t("components.artist_info.name3.validation.maxLength")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-3 mb-3"
            :label="$t('components.artist_info.artistic_name.label')"
            label-for="artistic_name"
          >
            <b-form-input
              id="artistic_name"
              type="text"
              :placeholder="$t('components.artist_info.artistic_name.placeholder')"
              v-model="artistic_name"
              :class="{ 'is-invalid': $v.artistic_name.$error }"
            ></b-form-input>
            <div v-if="$v.artistic_name.$error" class="invalid-feedback">
              <span v-if="!$v.artistic_name.minLength">{{
                $t("components.artist_info.artistic_name.validation.minLength")
              }}</span>
              <span v-if="!$v.artistic_name.maxLength">{{
                $t("components.artist_info.artistic_name.validation.maxLength")
              }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-4 mb-3">
            <label for="birth_date"
              >{{ $t("components.artist_info.birth_date.label")
              }}<span class="required">*</span></label
            >
            <date-picker
              id="birth_date"
              type="date"
              lang="ar"
              value-type="YYYY-MM-DD"
              format="YYYY-MM-DD"
              :placeholder="$t('components.artist_info.birth_date.placeholder')"
              v-model="birth_date"
              :class="{ 'is-invalid': $v.birth_date.$error }"
            ></date-picker>
            <div v-if="$v.birth_date.$error" class="invalid-feedback">
              <span v-if="!$v.birth_date.required">{{
                $t("components.artist_info.birth_date.validation.required")
              }}</span>
              <span v-if="!$v.birth_date.maxValue">{{
                $t("components.artist_info.birth_date.validation.maxValue")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-4 mb-3">
            <label for="gender_id"
              >{{ $t("components.artist_info.gender_id.label")
              }}<span class="required">*</span></label
            >
            <select
              class="form-control form-select"
              id="gender_id"
              v-model="gender_id"
              :class="{ 'is-invalid': $v.gender_id.$error }"
            >
              <option value="">
                {{ $t("components.artist_info.gender_id.default-option") }}
              </option>
              <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
                {{ gender.name }}
              </option>
            </select>
            <div v-if="$v.gender_id.$error" class="invalid-feedback">
              <span v-if="!$v.gender_id.required">{{
                $t("components.artist_info.gender_id.validation.required")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-4 mb-3"
            :label="$t('components.artist_info.email.label')"
            label-for="email"
          >
            <b-form-input
              id="email"
              type="email"
              :placeholder="$t('components.artist_info.email.placeholder')"
              v-model="email"
              :class="{ 'is-invalid': $v.email.$error }"
            ></b-form-input>
            <div v-if="$v.email.$error" class="invalid-feedback">
              <span v-if="!$v.email.email">{{
                $t("components.artist_info.email.validation.email")
              }}</span>
              <span v-if="!$v.email.maxLength">{{
                $t("components.artist_info.email.validation.maxLength")
              }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="col-md-6 mb-3">
            <label for="certificate_id"
              >{{ $t("components.artist_info.certificate_id.label")
              }}<span class="required">*</span></label
            >
            <select
              class="form-control form-select"
              id="certificate_id"
              v-model="certificate_id"
              :class="{ 'is-invalid': $v.certificate_id.$error }"
            >
              <option value="">
                {{ $t("components.artist_info.certificate_id.default-option") }}
              </option>
              <option
                v-for="certificate in list_certificate"
                :value="certificate.id"
                :key="certificate.id"
              >
                {{ certificate.name }}
              </option>
            </select>
            <div v-if="$v.certificate_id.$error" class="invalid-feedback">
              <span v-if="!$v.certificate_id.required">{{
                $t("components.artist_info.certificate_id.validation.required")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            :label="$t('components.artist_info.academic_specialization.label')"
            label-for="academic_specialization"
          >
            <b-form-input
              id="academic_specialization"
              type="text"
              :placeholder="
                $t('components.artist_info.academic_specialization.placeholder')
              "
              v-model="academic_specialization"
              :class="{ 'is-invalid': $v.academic_specialization.$error }"
            ></b-form-input>
            <div v-if="$v.academic_specialization.$error" class="invalid-feedback">
              <span v-if="!$v.academic_specialization.minLength">{{
                $t("components.artist_info.academic_specialization.validation.minLength")
              }}</span>
              <span v-if="!$v.academic_specialization.maxLength">{{
                $t("components.artist_info.academic_specialization.validation.maxLength")
              }}</span>
            </div>
          </b-form-group>
        </div>

        <div class="row">
          <b-form-group class="col-md-6 mb-3">
            <label for="country_id"
              >{{ $t("components.artist_info.country_id.label")
              }}<span class="required">*</span></label
            >
            <multiselect
              id="country_id"
              v-model="country_id"
              :placeholder="$t('components.artist_info.country_id.placeholder')"
              label="name"
              track-by="id"
              :options="list_country"
              :option-height="104"
              :show-labels="false"
              :class="{ 'is-invalid': $v.country_id.$error }"
            >
              <template #singleLabel="props">
                <img
                  class="option__image"
                  :src="
                    'https://flagcdn.com/16x12/' +
                    props.option.code.toLowerCase() +
                    '.png'
                  "
                  alt="no-image"
                />
                <span class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>

              <template #option="props">
                <img
                  class="option__image"
                  :src="
                    'https://flagcdn.com/16x12/' +
                    props.option.code.toLowerCase() +
                    '.png'
                  "
                  alt="no-image"
                />
                <div class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </div>
              </template>
              <template #noResult>
                <span>{{ $t("components.artist_info.country_id.no_result") }}</span>
              </template>
            </multiselect>
            <div v-if="$v.country_id.$error" class="invalid-feedback">
              <span v-if="!$v.country_id.required">{{
                $t("components.artist_info.country_id.validation.required")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-6 mb-3" v-if="isIraq()">
            <label for="city_id"
              >{{ $t("components.artist_info.city_id.label")
              }}<span class="required">*</span></label
            >

            <select
              class="form-control form-select"
              id="city_id"
              v-model="city_id"
              :class="{ 'is-invalid': $v.city_id.$error }"
            >
              <option value="">
                {{ $t("components.artist_info.city_id.default-option") }}
              </option>
              <option v-for="city in list_city" :value="city.name" :key="city.id">
                {{ city.name }}
              </option>
            </select>
            <div v-if="$v.city_id.$error" class="invalid-feedback">
              <span v-if="!$v.city_id.required">{{
                $t("components.artist_info.city_id.validation.required")
              }}</span>
            </div>
          </b-form-group>
          <b-form-group class="col-md-6 mb-3" v-else>
            <label for="city_name"
              >{{ $t("components.artist_info.city_name.label")
              }}<span class="required">*</span></label
            >
            <b-form-input
              id="city_name"
              type="text"
              :placeholder="$t('components.artist_info.city_name.placeholder')"
              v-model="city_name"
              :class="{ 'is-invalid': $v.city_name.$error }"
            ></b-form-input>
            <div v-if="$v.city_name.$error" class="invalid-feedback">
              <span v-if="!$v.city_name.required">{{
                $t("components.artist_info.city_name.validation.required")
              }}</span>
              <span v-if="!$v.city_name.minLength">{{
                $t("components.artist_info.city_name.validation.minLength")
              }}</span>
              <span v-if="!$v.city_name.maxLength">{{
                $t("components.artist_info.city_name.validation.maxLength")
              }}</span>
            </div>
          </b-form-group>
        </div>

        <div class="row">
          <b-form-group class="col-md-6 mb-3">
            <label for="phone1">
              {{ $t("components.artist_info.phone1.label") }}
              <span class="required">*</span>
            </label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ phone1Prefix }}</span>
              </div>
              <b-form-input
                id="phone1"
                type="number"
                v-model="phone1"
                :disabled="!isCountrySelected"
                :placeholder="$t('components.artist_info.phone1.placeholder')"
                :class="{ 'is-invalid': $v.phone1.$error }"
                class="special-phone"
              ></b-form-input>
              <div class="text-muted font-size-13 w-100">
                {{ $t("components.artist_info.phone1.note") }}
              </div>
              <div v-if="$v.phone1.$error" class="invalid-feedback">
                <span v-if="!$v.phone1.required">
                  {{ $t("components.artist_info.phone1.validation.required") }}
                </span>
                <span v-if="!$v.phone1.minLength || !$v.phone1.maxLength">
                  {{ $t("components.artist_info.phone1.validation.minLength") }}
                  {{ phoneLength }}
                  {{ $t("components.artist_info.phone1.validation.maxLength") }}
                </span>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-6 mb-3"
            :label="$t('components.artist_info.phone2.label')"
            label-for="phone2"
          >
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ phone2Prefix }}</span>
              </div>
              <b-form-input
                id="phone2"
                type="number"
                v-model="phone2"
                :disabled="!isCountrySelected"
                :placeholder="$t('components.artist_info.phone2.placeholder')"
                :class="{ 'is-invalid': $v.phone2.$error }"
                class="special-phone"
              ></b-form-input>
              <!-- <div class="text-muted font-size-13 w-100">
                {{ $t("components.artist_info.phone2.note") }}
              </div> -->
              <div v-if="$v.phone2.$error" class="invalid-feedback">
                <span v-if="!$v.phone2.minLength || !$v.phone2.maxLength">
                  {{ $t("components.artist_info.phone2.validation.minLength") }}
                  {{ phoneLength }}
                  {{ $t("components.artist_info.phone2.validation.maxLength") }}
                </span>
              </div>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
